import { Paper, Stack, Typography } from "@mui/material";
import React from "react";
import { RuleToken } from "./commons";
interface SingleTokenProps {
  token: RuleToken;
  index: number;
}

const SingleToken: React.FC<SingleTokenProps> = ({ token, index }) => {
  const { value, testMeta, checkValue, testMeta2, checkValue2, valueIfTrue, valueIfFalse } = token;
  return (
    <Paper sx={{ ml: index === 0 ? "12px !important" : 0 }}>
      <Stack p={1} alignItems={"center"} flexWrap={"wrap"} spacing={1} direction={"row"}>
        {value && <Typography>{value}</Typography>}
        {testMeta && <Typography>{testMeta}</Typography>}
        {testMeta && <Typography color={"text.tier"}>==</Typography>}
        {checkValue && <Typography>'{checkValue}'</Typography>}
        {testMeta && !checkValue && <Typography>''</Typography>}
        {testMeta && testMeta2 && <Typography color={"text.tier"}>&&</Typography>}
        {testMeta2 && <Typography>{testMeta2}</Typography>}
        {testMeta2 && <Typography color={"text.tier"}>==</Typography>}
        {checkValue2 && <Typography>'{checkValue2}'</Typography>}
        {testMeta2 && !checkValue2 && <Typography>''</Typography>}
        {testMeta && <Typography color={"text.tier"}>?</Typography>}
        {valueIfTrue && <Typography color={"info"}>'{valueIfTrue}'</Typography>}
        {testMeta && !valueIfTrue && <Typography>''</Typography>}
        {testMeta && <Typography color={"text.tier"}>:</Typography>}
        {testMeta && <Typography color={"warning"}>'{valueIfFalse}'</Typography>}
      </Stack>
    </Paper>
  );
};

export default SingleToken;
